import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function Footer({ scrollTo }) {
  const [ist, setIst] = useState("");

  useEffect(() => {
    const tick = () =>
      setIst(
        new Intl.DateTimeFormat("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
          timeZone: "Asia/Kolkata",
        }).format(new Date())
      );
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer data-testid="site-footer" className="bg-[#0A0E17] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 grid place-items-center bg-[#F59E0B] text-[#0A0E17] font-display font-extrabold text-sm rounded-sm">SI</span>
            <span className="font-display font-bold tracking-tight text-lg uppercase">
              Shivin <span className="text-[#F59E0B]">Infotech</span>
            </span>
          </div>
          <p className="mt-5 font-mono2 text-xs leading-relaxed text-slate-400 uppercase tracking-wider max-w-sm">
            Ramjhora Tea Garden, Prem Nagar, P.O. Ramjhora, P.S. Birpara,
            Dist. Alipurduar, PIN 735228 — West Bengal, India
          </p>
          <p className="mt-4 font-mono2 text-[10px] tracking-[0.25em] text-slate-500 uppercase">
            26°49'N 89°01'E · Indo-Bhutan Trade Corridor
          </p>
        </div>

        <div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-5">Navigate</p>
          <ul className="space-y-3">
            {[
              ["Services", "#services", "footer-link-services"],
              ["Estimator", "#estimator", "footer-link-estimator"],
              ["About", "#about", "footer-link-about"],
              ["Contact", "#contact", "footer-link-contact"],
            ].map(([label, href, testid]) => (
              <li key={href}>
                <button
                  data-testid={testid}
                  onClick={() => scrollTo(href)}
                  className="font-mono2 text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-[#F59E0B] transition-colors duration-300"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-5">Direct Line</p>
          <ul className="space-y-3 font-mono2 text-xs text-slate-300 tracking-wider">
            <li><a data-testid="footer-phone-1" href="tel:7407037269" className="hover:text-[#F59E0B] transition-colors duration-300">+91 74070 37269</a></li>
            <li><a data-testid="footer-phone-2" href="tel:7908611427" className="hover:text-[#F59E0B] transition-colors duration-300">+91 79086 11427</a></li>
            <li><a data-testid="footer-email" href="mailto:director@transgistics.in" className="hover:text-[#F59E0B] transition-colors duration-300">director@transgistics.in</a></li>
          </ul>
          <div data-testid="footer-ist-clock" className="mt-6 flex items-center gap-2 font-mono2 text-[11px] text-slate-500">
            <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse-dot" />
            IST {ist}
          </div>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} Shivin Infotech · All rights reserved
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollTo("#top")}
            className="flex items-center gap-2 font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-400 hover:text-[#F59E0B] transition-colors duration-300"
          >
            Back to top <ArrowUp size={13} />
          </button>
        </div>
      </div>
    </footer>
  );
}
